import currencyFormat, {
    ICurrencyFormatOption,
} from 'Services/localize/currencyFormat'

export const currency = (
    value: number | string,
    language: string | undefined | null = undefined,
    otherCurrencyCode: string,
    options: ICurrencyFormatOption = {
        fraction: true,
        isAccounting: false,
    },
) => {
    return currencyFormat(value, language || 'en', otherCurrencyCode, options)
}
